import LegalShell from '@/components/LegalShell';
import { Sparkles, Heart, Leaf, Users } from 'lucide-react';

export default function AboutPage() {
  return (
    <LegalShell eyebrow="About" title="Our story." data-testid="about-page">
      <div data-testid="about-page" className="space-y-6">
        <p className="text-lg leading-relaxed text-foreground/85">
          <strong>Radiance Hub</strong> is a quiet-luxury beauty journal for women — a calm, curated space
          for DIY rituals, regional product discovery, and AI-powered personal styling. We believe beauty
          should feel like a thoughtful practice, not a pressure.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 not-prose mt-8">
          {[
            { icon: Sparkles, title: 'AI-powered personalization', body: 'Daily regimens, lifestyle suggestions and AI styling tailored to your skin, region and weather.' },
            { icon: Heart, title: 'Curated, never pushy', body: 'We surface trusted picks across skincare, hair, jewelry and perfumes — with no aggressive selling.' },
            { icon: Leaf, title: 'Global & regional', body: '127+ products spanning India, UAE, US, UK, EU, Singapore, Australia and beyond.' },
            { icon: Users, title: 'Community-driven', body: 'Real reviews from women in our community help guide what to try next.' },
          ].map(({ icon: Icon, title, body }) => (
            <div key={title} className="rounded-2xl bg-cream-paper border border-border/70 p-5">
              <div className="h-9 w-9 rounded-xl bg-accent/60 border border-rose-tint flex items-center justify-center">
                <Icon className="h-4.5 w-4.5 text-rose-gold" />
              </div>
              <h3 className="mt-3 font-display text-xl text-ink">{title}</h3>
              <p className="mt-1 text-sm text-foreground/80 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        <section className="mt-8">
          <h2 className="font-display text-2xl text-ink">Who we are</h2>
          <p className="mt-2 text-foreground/85 leading-relaxed">
            Radiance Hub is operated by the <strong>Radiance Hub Team</strong>, based in Mumbai,
            Maharashtra, India. We build with a small, focused team of designers, engineers and
            beauty editors who care deeply about bringing calm, useful, elegant experiences to
            the women we serve.
          </p>
        </section>

        <section className="mt-8">
          <h2 className="font-display text-2xl text-ink">What we don’t do</h2>
          <ul className="mt-2 space-y-1.5 text-foreground/85 leading-relaxed list-disc pl-5">
            <li>We don’t sell products ourselves — we’re an information-only curator.</li>
            <li>We don’t share your data with advertisers.</li>
            <li>We don’t pretend to replace a dermatologist for medical concerns.</li>
          </ul>
        </section>

        <section className="mt-8">
          <h2 className="font-display text-2xl text-ink">Get in touch</h2>
          <p className="mt-2 text-foreground/85 leading-relaxed">
            For feedback, partnership or support queries, write to us at{' '}
            <a className="text-foreground underline underline-offset-4" href="mailto:Webuser@radiancehub.org">
              Webuser@radiancehub.org
            </a>.
          </p>
        </section>
      </div>
    </LegalShell>
  );
}
